// @ts-nocheck
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

export function useTeamRole(teamId: string | undefined) {
  const { user } = useAuth();
  return useQuery({
    queryKey: ['team-role', teamId, user?.id],
    enabled: !!teamId && !!user,
    queryFn: async () => {
      const { data } = await (supabase as any)
        .from('team_members')
        .select('role, is_primary_billing, can_edit_roster, can_view_billing, can_register_for_events')
        .eq('team_id', teamId)
        .eq('user_id', user!.id)
        .eq('status', 'active');
      const rows = data ?? [];
      const roles = rows.map((r: any) => r.role);
      return {
        roles,
        isOwner: roles.includes('team_owner'),
        isManager: roles.includes('team_manager'),
        isHeadCoach: roles.includes('head_coach'),
        isBillingContact: rows.some((r: any) => r.is_primary_billing),
        canEditRoster: rows.some((r: any) => r.can_edit_roster),
        canViewBilling: rows.some((r: any) => r.can_view_billing),
        canRegister: rows.some((r: any) => r.can_register_for_events),
        isMember: rows.length > 0,
        isAdmin: roles.includes('team_owner') || roles.includes('team_manager'),
      };
    },
  });
}
